import { render } from "./SmallLoadingSpinnerIcon.vue?vue&type=template&id=2d1bef1c"
const script = {}
script.render = render

export default script